@let isLoading = isLoading$ | async;
@let adapterCards = adaptersCards$ | async;

@if (isLoading === false && adapterCards) {
  <div class="adapters">
    <div class="page-header">
      <div class="page-header-top">
        <div class="page-title">Adapters</div>
        <app-button
          [isEnabled]="
            adapterCards.length < this.maxAdapters &&
            this.permissionsService.userHasPermission(PERMISSIONS.INTEGRATION_OPERATION)
          "
          buttonIconPath="assets/images/common/plus.svg"
          tooltipPosition="left"
          [disabledTooltipText]="disabledAddAdapterButtonReason"
          (buttonClicked)="addAdapter()"
          buttonTextLabelPath="adaptersPage.addButton"
        ></app-button>
      </div>
      <div class="page-subtitle">
        Adapters enable Zenity to push alerts, insights, and actions to your external systems.
      </div>
    </div>
    <div class="cards-actions">
      <span class="adapters-count"
        >{{ adapterCards.length }} adapter{{ adapterCards.length !== 1 ? 's' : '' }}</span
      >
    </div>
    @if (adapterCards.length > 0) {
      <div class="adapters-cards">
        @for (card of adapterCards; track card.cardId) {
          <app-data-card [card]="card" (cardOnClick)="onCardActionClicked($event)"></app-data-card>
        }
      </div>
    } @else {
      <app-no-data></app-no-data>
    }
  </div>
} @else {
  <div class="adapters-spinner">
    <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
  </div>
}
